import { HotelGroupBookings } from "../../../../HotelGroups/Bookings"
import { IHotelGroup } from "../../../../HotelGroups"
import { useOutletContext } from "../../../../router-utils"
import { Helmet } from "react-helmet-async"

export default function HotelGroupBookingsPage() {
	const { group } = useOutletContext<{ group: IHotelGroup }>()
	return (
		<>
			<Helmet>
				<title>Bookings | Hotel Group</title>
			</Helmet>
			<HotelGroupBookings group={group} />
		</>
	)
}
